"use strict";

require("core-js/modules/es.promise");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeatureURL = void 0;

var _fullscript = require("../fullscript");

var _fullscriptJsValidator = require("../fullscriptJsValidator");

var _utils = require("../utils");

var _featurePath = require("./featurePath");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var getFeatureURL = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (featureType, featureOptions, fullscriptOptions, frameId) {
    var {
      publicKey,
      env,
      domain
    } = fullscriptOptions;
    var queryString = yield (0, _utils.buildQueryString)(_objectSpread(_objectSpread({}, featureOptions), {}, {
      fullscriptOptions,
      publicKey,
      frameId
    }));
    (0, _fullscriptJsValidator.validateFeatureType)(featureType);
    var fsDomain = domain !== null && domain !== void 0 ? domain : _fullscript.FULLSCRIPT_DOMAINS[env];
    return "".concat(fsDomain, "/api/embeddable/session").concat(_featurePath.FEATURE_PATHS[featureType]).concat(queryString, "&target_origin=").concat(window.location.origin);
  });

  return function getFeatureURL(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

exports.getFeatureURL = getFeatureURL;